export const awareness = [
  {
    number: 'BC100',
    hasModel: false,
  },
  {
    number: 'BC101',
    hasModel: false,
  },
  {
    number: 'BC102',
    hasModel: false,
  },
  {
    number: 'BC103',
    hasModel: false,
  },
  {
    number: 'BC104',
    hasModel: false,
  },
  {
    number: 'BC105',
    hasModel: false,
  },
  {
    number: 'BC106',
    hasModel: false,
  },
  {
    number: 'BC107',
    hasModel: false,
  },
  {
    number: 'BC108',
    hasModel: false,
  },
  {
    number: 'BC109',
    hasModel: false,
  },
  {
    number: 'BC110',
    hasModel: false,
  },
  {
    number: 'BC111',
    hasModel: false,
  },
  {
    number: 'BC112',
    hasModel: false,
  },
  {
    number: 'BC113',
    hasModel: false,
  },
  {
    number: 'BCX',
    hasModel: false,
  },
];
